import { createContext, useContext } from 'react'

type ChatMode = 'popup' | 'sidebar' | 'chat'

interface AiChatContextValue {
  mode: ChatMode
  onClose: () => void
  showContactForm: boolean
  setShowContactForm: (v: boolean) => void
  humanModeActive: boolean
  humanModeStartedAt: number | null
}

export const AiChatContext = createContext<AiChatContextValue>({
  mode: 'popup',
  onClose: () => {},
  showContactForm: false,
  setShowContactForm: () => {},
  humanModeActive: false,
  humanModeStartedAt: null,
})

export function useAiChatContext() {
  return useContext(AiChatContext)
}
